var map = {
	"./gallary-1.jpg": 195,
	"./gallary-2.jpg": 564,
	"./gallary-3.jpg": 609,
	"./gallary-4.jpg": 594,
	"./gallary-5.jpg": 879,
	"./gallary-6.jpg": 264,
	"./gallary-7.JPG": 536,
	"./gallary-8.JPG": 923,
	"./gallary-9.JPG": 734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 596;